import * as React from 'react';
import { withRouteData } from 'react-static';
import { ChildDataProps, graphql } from 'react-apollo';
import Slider from 'react-slick';

import { StatisticsPageLocale } from '../../components/StatisticsPage/statisticsPage.locale';
import StatisticsComponent from '../../components/StatisticsPage/StatisticsPage';
import { Query, TimestampTraffic, TrafficsQueryArgs } from '../../GraphQL';
import statisticsQuery from './statisticsQuery.gql';

interface RouteProps {
  locale: StatisticsPageLocale;
}

interface StatisticsPageProps extends ChildDataProps<RouteProps, Query, TrafficsQueryArgs> {}

interface StatisticsPageState {
  activeGraphIndex: number;
}

class StatisticsPage extends React.PureComponent<StatisticsPageProps, StatisticsPageState> {
  sliderRef: React.RefObject<Slider> = React.createRef();

  state: StatisticsPageState = {
    activeGraphIndex: 1,
  };

  setActiveGraph = (index: number) => this.setState({ activeGraphIndex: index });

  render() {
    const { locale, data } = this.props;
    const traffics = (data.traffics as TimestampTraffic[][] | undefined) || [
      ...locale.graphs.map(() => []),
    ];
    return (
      <StatisticsComponent
        locale={locale}
        traffics={traffics}
        activeGraphIndex={this.state.activeGraphIndex}
        setActiveGraph={this.setActiveGraph}
        sliderRef={this.sliderRef}
        loading={this.props.data.loading}
      />
    );
  }
}

export default withRouteData(
  graphql<RouteProps, Query, TrafficsQueryArgs, StatisticsPageProps>(statisticsQuery, {
    options: ({ locale }) => {
      const cacheLifetime = 1000 * 60 * 10;
      const unixNow = Math.floor(
        new Date(Math.floor(Date.now() / cacheLifetime) * cacheLifetime).getTime() / 1000,
      );
      return {
        variables: {
          timestampRanges: [
            ...locale.graphs.map(graph => ({
              since: unixNow - graph.periodLength,
              until: unixNow,
            })),
          ],
        },
      };
    },
  })(StatisticsPage),
);



// WEBPACK FOOTER //
// /www/client/src/containers/StatisticsPage/StatisticsPage.tsx